import React from 'react';
import NavBar from './navbar/NavBar';
import { IoMdClose } from 'react-icons/io';
import '../style/Home.scss';
import { useNavigate } from "react-router-dom";
import flower from '../assets/01_home/1.svg';
import home from '../assets/01_home/home.webp';
import clownbesuche from '../assets/01_home/clownbesuche.webp';
import unterhaltung from '../assets/01_home/unterhaltung.webp';
import clowntheater from '../assets/01_home/clowntheater.webp';

function Home() {
    const navigate = useNavigate();

    function closeMenu() {
        document.getElementById('menu').style.visibility = 'hidden';
        document.getElementById('fabars').style.visibility = 'visible';
        document.getElementById('fabars2').style.visibility = 'visible';
    }

    function navigate1() {
        navigate("/ueber-uns");
    }

    function navigate2() {
        navigate("/referenzen");
    }

    function navigate3() {
        navigate("/kontakt");
    }

    return (
        <div className='App'>
            <div id='menu' className='menu'>
                <div className='menu-esc-container'>
                    <div className='menu-esc' onClick={closeMenu}>
                        <IoMdClose size={'6vh'}/>
                    </div>
                </div>
                <div className='menu-items-container'>
                    <div className='menu-item' onClick={navigate1} >Über uns</div>
                    <div className='menu-item' onClick={navigate2} >Referenzen</div>
                    <div className='menu-item' onClick={navigate3} >Kontakt</div>
                </div>
            </div>
            <NavBar />
            <div className='header'>
                <img className='image' src={home} alt=''></img>
            </div>
            <div className='body'>
                <div className='text-block'>
                    Freue dich an den kleinen Dingen im Leben, denn sie machen das Leben grossartig!
                    <div className='small-img'>
                        <img className='image' src={flower} alt=''></img>
                    </div>
                </div>
                <div className='title-block'>
                    Freude schenken
                </div>
                <div className='categories-block'>
                    <div className='category'>
                        <div className='category-title'>
                            Unterhaltung
                        </div>
                        <div className='category-img'>
                            <img className='image' src={unterhaltung} alt=''></img>
                            <div className='category-text'>
                            Geburtstage, Sommerfeste, Hochzeiten, Eröffnungen – gerne mischen wir uns unter die Leute oder bieten ein 15-20 minütiges Clowntheater an.<br></br><br></br>
                            Unser Clowntheater ist für Gross und Klein sehr spannend. Wir sprechen das sogenannte «Gromolo». Das tolle daran – jeder versteht es! Dazu natürlich eine grosse Portion an Mimik und Gestik. Und damit ein optimales Theaterfeeling entsteht, bringen wir einen Vorhang mit.<br></br><br></br>
                            So könnten 90 Minuten aussehen: Wir machen ein 20-minütiges Clowntheater, 40 Minuten mischen wir uns unter die Leute und 30 Minuten formen wir Ballone. (Ballone formen wir nur in Kombination von Clowntheater und/oder unter die Leute mischen).<br></br><br></br>
                            Interessiert? Dann melde dich via Kontakt bei uns, gerne besprechen wir mit dir, eine passende Unterhaltung.
                            </div>
                        </div>
                    </div>
                    <div className='category'>
                        <div className='category-title'>
                            Clown-Theater
                        </div>
                        <div className='category-img'>
                            <img className='image' src={clowntheater} alt=''></img>
                            <div className='category-text'>
                            Wir entwickeln gerne ein Theaterstück zu einem bestimmten Thema oder zu einem Bibelvers. Die Dauer ist sehr unterschiedlich, zwischen 10 Minuten und 35 Minuten, je nach Wunsch des Auftraggebers.
                            <br></br>
                            <br></br>
                            Jedes Theaterstück hat eigen komponierte Musik oder auch Lieder, wir haben verschiedene Musikinstrumente, Jonglieren oder machen Zaubertricks – JA wir lieben die Clownneske Freiheit
                            <br></br>
                            <br></br>
                            Mit unseren Handpuppen Rico und Charlie können wir im Voraus eine Einleitung zum Clowntheater machen. In Worten ein Thema aufgreifen und danach kommt das Clownpaar. Als Clownpaar sprechen wir das sogenannte «Gromolo».
                            <br></br>
                            <br></br>
                            Interessiert? Dann melde dich via Kontakt bei uns!
                            </div>
                        </div>
                    </div>
                    <div className='category'>
                        <div className='category-title'>
                            Clown-Besuche
                        </div>
                        <div className='category-img'>
                            <img className='image' src={clownbesuche} alt=''></img>
                            <div className='category-text'>
                            Wir glauben, dass es Clowns in Pflegeinstitutionen braucht. Als Clown haben wir die Möglichkeit die Bewohner anders abzuholen als das Pflegepersonal, Angehörige oder Besucher. Die Bewohner können mit uns eine unbeschwerte Zeit erleben. Wir können mit ihnen in eine Welt eintauchen, die zum Träumen führt oder anregt. Die Bewohner haben die Möglichkeit von ihren Sorgen zu erzählen oder von früher, was sie schon alles erlebt haben. Das Singen vertrauter Lieder weckt schöne Erinnerungen und fördert die Wahrnehmung. Oft und gerne improvisieren wir ein ganz persönliches Lied. So entstand schon ein Fitness-Lied, Zimmer-Lied, Katzen-Lied und viele andere. Wir singen auch bekannte Lieder wie z.B. «Wir sind mit dem Velo da».<br></br><br></br>
                            Durch unsere Anwesenheit zieht Abwechslung und Fröhlichkeit ein. Die Bewohner haben Gesellschaft. Stress und Anspannung werden reduziert und auch Angst kann genommen werden. Schmerzen werden weniger wahrgenommen.<br></br><br></br>
                            Wir begegnen mit Respekt, Achtsamkeit und voller Präsenz.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='footer'>
                Copyright {new Date().getFullYear()} © Damaris & Lukas Steiner
            </div>
        </div>
    );
}

export default Home;